import { WeightUnit } from "@/Common/Utilities/Units/Units";
import { ObstetricalHistoryItem } from "../ObstetricalHistoryItem";
import { OntarioObstetricalMedicalHistory } from "./OPR1/OntarioObstetricalMedicalHistory";
import { OntarioObstetricalPatientPersonalInformation } from "./OPR1/OntarioObstetricalPatientPersonalInformation";
import { OntarioObstetricalPregnancySummary } from "./OPR1/OntarioObstetricalPregnancySummary";
import { OntarioObstetricalSignatureBlock } from "./OPR1/OntarioObstetricalSignatureBlock";

class OntarioObstetricalFileFormOpr1 {
    public PregnancySummary: OntarioObstetricalPregnancySummary;
    public PersonalInformation: OntarioObstetricalPatientPersonalInformation;
    public ObstetricalHistory: ObstetricalHistoryItem[];
    public ObstetricalHistoryMassUnit: WeightUnit;
    public MedicalHistory: OntarioObstetricalMedicalHistory;
    public SignaturesBlock: OntarioObstetricalSignatureBlock;

    constructor(fields?: Partial<OntarioObstetricalFileFormOpr1>) {
        this.PersonalInformation = new OntarioObstetricalPatientPersonalInformation(fields?.PersonalInformation);
        this.PregnancySummary = new OntarioObstetricalPregnancySummary(fields?.PregnancySummary);
        this.ObstetricalHistory = fields?.ObstetricalHistory?.map(p => new ObstetricalHistoryItem(p)) ?? [];
        this.MedicalHistory = new OntarioObstetricalMedicalHistory(fields?.MedicalHistory);
        this.SignaturesBlock = new OntarioObstetricalSignatureBlock(fields?.SignaturesBlock);
        this.ObstetricalHistoryMassUnit = fields?.ObstetricalHistoryMassUnit ?? (sessionStore.useMetricSystemAsDefault ? WeightUnit.Gram : WeightUnit.Pound);
    }
}

export { OntarioObstetricalFileFormOpr1 };
